import http from "./httpService";
import { apiUrl } from "../config";

export const postDeliveryConcern = (deliveryConcernRequest) => {
  return http.post(
    `${apiUrl}DeliveryConcern/PostDeliveryConcern`,
    deliveryConcernRequest
  );
};

export const getDeliveryConcern = (deliveryConcernId) => {
  return http.get(`${apiUrl}DeliveryConcern/GetDeliveryConcernsDetails`, {
    params: { deliveryConcernId },
  });
};

export const reopenDeliveryConcern = (deliveryConcernRequest) => {
  //ReopenDeliveryConcern
  return http.put(
    `${apiUrl}DeliveryConcern/ReopenDeliveryConcern`,
    deliveryConcernRequest
  );
};

// export const getDeliveryConcerns = (searchRequest) => {
//     return http.post(`${apiUrl}DeliveryConcern/GetDeliveryConcerns`, searchRequest);
// }

export const getDeliveryConcerns = () => {
  return http.post(`${apiUrl}DeliveryConcern/GetDeliveryConcerns`);
};

export const getRouteUpdatesForClient = () => {
  return http.get(`${apiUrl}DeliveryConcern/DeliveryConcernMessage`);
};

export const getMostRecentRouteUpdateForRoute = (route) => {
  return http.get(`${apiUrl}DeliveryConcern/GetCurrentConcernMessage`, {
    params: { route },
  });
};
